import { useMemo } from "react";
import { useGetMatchQuery } from "../../../services/objects";
import { ValueDisplay, ValueDisplayWithLabel } from "../../components/ValueDisplay";
import { Block } from "baseui/block";
import { FaGripfire } from "react-icons/fa";
import { ParagraphXSmall } from "baseui/typography";
import { IoIosSnow } from "react-icons/io";
import { FormattedMessage, useIntl } from "react-intl";
import { modelId as RoomModelId } from './types'
import { useStyletron } from "baseui";

export const enum ORIENTATION {
    Horizontal,
    Vertcal
}

export const RoomsOverviewPanel = (props: { parentId: string, resourceGroupId: string, orientation?: ORIENTATION }) => {
    const [, theme] = useStyletron();
    const intl = useIntl();
    // api
    const { data: rooms } = useGetMatchQuery(
        { objectId: props.parentId, resourceGroupId: props.resourceGroupId, hops: '..3', relationship: 'Contains', modelId: RoomModelId }
    ,{skip: !props.parentId || !props.resourceGroupId});

    const { numRooms, numRoomsHeating, numRoomsCooling } = useMemo(() => {
        return {
            numRooms: rooms?.length || 0,
            numRoomsHeating: rooms?.filter((c) => c.isHeating).length || 0,
            numRoomsCooling: rooms?.filter((c) => c.isCooling).length || 0,
        }
    }, [rooms]);


    const flexDir = props.orientation !== undefined ? props.orientation === ORIENTATION.Horizontal ? 'row' : 'column' : 'column'

    return (
        <Block display={'flex'} flexDirection={flexDir} alignItems={'center'} gridColumnGap={theme.sizing.scale800}>
            {numRooms > 0 && <ValueDisplay small value={numRooms} dimension={numRooms !== 1 ? intl.formatMessage({ id: `SP_Room.Rooms`, defaultMessage: 'Rooms' }) : intl.formatMessage({ id: `P_Floor.Room`, defaultMessage: 'Room' })} ></ValueDisplay>}
            {numRoomsHeating > 0 &&
                <Block display='inline-flex' alignItems={'baseline'} gridGap={theme.sizing.scale100}>
                    <FaGripfire size='1.0em' color={theme.colors.negative400}></FaGripfire>
                    <ValueDisplayWithLabel label={""} small value={numRoomsHeating}></ValueDisplayWithLabel>

                    <ParagraphXSmall margin={0} color={theme.colors.primary500}>
                        {numRoomsHeating === 1 ?
                            <FormattedMessage id="SP_Room.RoomBeeingHeated" defaultMessage="room being heated" />
                            :
                            <FormattedMessage id="SP_Room.RoomsBeeingHeated" defaultMessage="rooms being heated" />
                        }
                    </ParagraphXSmall>
                </Block>
            }
            {numRoomsCooling > 0 &&
                <Block display='inline-flex' alignItems={'baseline'} gridGap={theme.sizing.scale100}>
                    <IoIosSnow size='1.0em' color={theme.colors.accent300}></IoIosSnow>
                    <ValueDisplayWithLabel label={""} small value={numRoomsCooling}></ValueDisplayWithLabel>
                    <ParagraphXSmall margin={0} color={theme.colors.primary500}>
                        {numRoomsCooling === 1 ?
                            <FormattedMessage id="SP_Room.RoomBeeingCooled" defaultMessage="room being cooled" />
                            :
                            <FormattedMessage id="SP_Room.RoomsBeeingCooled" defaultMessage="rooms being cooled" />
                        }
                    </ParagraphXSmall>
                </Block>}
        </Block>
    )

}
